import type { FaireProductEntity } from "../../entity_types/product";

export const p_jph4gae55y: FaireProductEntity = {
  token: "p_jph4gae55y",
  type: "product",
  name: "Mommy and Me Leopard Sweater Cardigan with Black Ribbon Bows",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/b4449d1292c15757cfdcf2fb26d3bfe0ccd20152c595656c8e08ecbea1c210b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/720f11a323d482816adf8754c7437e9b3865e09ee8ae011e8ff627144005460b.jpeg",
    "https://cdn.faire.com/fastly/1d47b90d601c7046b81fe6212d85e9db38928e60919beaddc150fa286ad3cb35.jpeg",
    "https://cdn.faire.com/fastly/46a36eb90219e9cd66eb9c0a41837b39d807ec804428f3e5e8739a429e00bdba.jpeg",
    "https://cdn.faire.com/fastly/c9de4c337bdd3973a163118b092340ff090a1cd4d3f8fcf25b67f1dc52ebfe82.jpeg",
    "https://cdn.faire.com/fastly/211f270f2b6536427f935c5f787a4bc400816ac76b60a0ae072aafccafec16d6.jpeg",
  ],
  priceDollars: 26.5,
  description:
    "Celebrate special moments in matching style with the Mommy and Me Leopard Sweater Cardigan. Featuring a chic leopard print and delicate black ribbon bows, this cozy cardigan brings warmth and a touch of elegance to both mother and child. Perfect for layering, it offers comfort without sacrificing fashion, making it ideal for outings or relaxed days at home. Create unforgettable memories while looking effortlessly coordinated.\n\nKids SKU:TPG60027\n\n\nAdult SKU:TPW60016\n\nMaterial:100%polyester\n\n\n",
  tags: [],
  msrpDollars: 53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:42.602Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
